module.exports = __webpack_public_path__ + "img/filter_expanded.03e92e0c.png";